import { inject, Injectable, InjectionToken } from '@angular/core';
import {
  SELF_SERVICE,
} from '@storees/shared-constants';
import { environment } from '@storees/environments';
import { RestApiService } from './rest-api.service';
import { Configuration, FrontendApi } from '@ory/client';
import { CapacitorCookies, CapacitorHttp } from '@capacitor/core';
import { useOryBaseUrlIfNecessary } from '../utils/utils';
import { ORY_TO_SESSION_TIMEOUT_MS } from '../utils/async-timeout';
import { AuthService } from './auth-service';

const { authBaseUrl, stackName } = environment;

export const ORY_CONFIG_TOKEN = new InjectionToken<FrontendApi>(
  'ORY_CONFIG_TOKEN',
  {
    providedIn: 'root',
    factory: () => {
      return new FrontendApi(
        new Configuration({
          basePath: useOryBaseUrlIfNecessary(authBaseUrl, stackName),
          baseOptions: {
            withCredentials: true,
            timeout: ORY_TO_SESSION_TIMEOUT_MS,
          },
        })
      );
    },
  }
);

@Injectable({
  providedIn: 'root',
})
export class OryFlowService {
  private authService = inject(AuthService);

  private restApiService = inject(RestApiService);
  private frontend: FrontendApi;
  private authBaseUrl = authBaseUrl;

  constructor() {
    const frontendApi = inject<FrontendApi>(ORY_CONFIG_TOKEN);

    this.frontend = frontendApi;
    this.authBaseUrl = useOryBaseUrlIfNecessary(authBaseUrl, stackName);
  }

  fetchBrowserFlow(path: string) {
    const url = `${this.authBaseUrl}/${SELF_SERVICE}/${path}/browser`;

    return this.restApiService.get(url,
      {}, // params
      { // headers
        'Accept': 'application/json',
    });
  }

  async fetchBrowserFlowNative(path: string) {
    const url = `${this.authBaseUrl}/${SELF_SERVICE}/${path}/browser`;
    const headers = {
      'Accept': 'application/json',
    };
    return CapacitorHttp.get({ url, headers });
  }

  async selfServiceActionNative(path: string, payload: any) {
    const url = `${this.authBaseUrl}/${SELF_SERVICE}/${path}`;
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
    };

    return CapacitorHttp.post({ url, data: payload, headers });
  }

  selfServiceAction(path: string, payload: any) {
    const url = `${this.authBaseUrl}/${SELF_SERVICE}/${path}`;
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };

    return this.restApiService.post(url, payload, headers);
  }

  async signOut(): Promise<void> {
    try {
      const { data: flow } = await this.frontend.createBrowserLogoutFlow();
      await this.frontend.updateLogoutFlow({
        token: flow.logout_token,
      });
    } catch (error) {
      console.error('Ory signOut() Error', error);
    }

    await CapacitorCookies.clearAllCookies();
    await this.authService.clearSessionJwtToken();
  }

}
